import { Component, ElementRef, inject, input, output, signal } from '@angular/core';

import { MatIconModule } from '@angular/material/icon';

export interface OptionDropdownItem {
  value: string;
  label: string;
  title?: string;
  icon?: string;
}

/** Generic labeled trigger that reveals a flat, clickable list of options. */
@Component({
  selector: 'app-option-dropdown',
  standalone: true,
  imports: [MatIconModule],
  templateUrl: './option-dropdown.component.html',
  styleUrl: './option-dropdown.component.scss',
  host: { '(document:click)': 'onDocumentClick($event)' },
})
export class OptionDropdownComponent {
  readonly label = input.required<string>();
  readonly options = input<OptionDropdownItem[]>([]);
  readonly tone = input<'neutral' | 'accent'>('neutral');

  readonly optionSelected = output<string>();

  readonly isOpen = signal(false);

  private readonly elementRef = inject(ElementRef);

  togglePanel(event: Event): void {
    event.stopPropagation();
    if (this.options().length === 0) return;
    this.isOpen.update((open) => !open);
  }

  select(option: OptionDropdownItem): void {
    this.isOpen.set(false);
    this.optionSelected.emit(option.value);
  }

  onDocumentClick(event: Event): void {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.isOpen.set(false);
    }
  }
}
